/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import SavePromptModal from '../../../components/Modals/SavePromptModal';
import { EARLY_PAYOUT_INPUT, MODALS, PERMISSIONS } from '../../../constants';

import {
  checkPermisson,
  getActiveModal, getLeagues, getMarkets, getNextNavigationLink, requiresSaveBeforeNavigation,
} from '../../../selectors/common';
import { selectorEarlyPayoutSettings } from '../../../selectors/earlyPayoutSettings';
import validateFields from '../../../utils/validation';
import EarlyPayoutSettingsRow from './EarlyPayoutSettingsRow';
import { aGetEarlyPayoutSettingsRequest } from '../../../reducers';
import { aSetNavigationInfo, aSetOpenModal } from '../../../reducers/common';
import { aUpdateEarlyPayoutSettings } from '../../../reducers/earlyPayoutSettings';

const mapToProps = (state) => ({
  leagues: getLeagues(state),
  allMarkets: getMarkets(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
  earlyPayoutSettings: selectorEarlyPayoutSettings(state),
  activeModal: getActiveModal(state),
  requiresSaveBeforeNavigation: requiresSaveBeforeNavigation(state),
  nextNavigationLink: getNextNavigationLink(state),

});

const actionsToProps = (dispatch) => ({
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  getEarlyPayoutSettings: (payload) => dispatch(aGetEarlyPayoutSettingsRequest(payload)),
  setNavigationInfo: (payload) => dispatch(aSetNavigationInfo(payload)),
  saveEarlyPayoutSettings: (payload) => dispatch(aUpdateEarlyPayoutSettings(payload)),
});

class EarlyPayoutConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLeagueId: 1,
      nextLeagueId: null,
      earlyPayoutSettings: null,

      initialSelectedLeagueDetails: null,
      selectedLeagueDetails: null,

      showCancelModal: false,
      hasChanges: false,

      errors: {},
    };
  }

  componentDidMount() {
    this.props.getEarlyPayoutSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.earlyPayoutSettings === null && this.props.earlyPayoutSettings !== null) {
      this.setState({
        earlyPayoutSettings: this.props.earlyPayoutSettings,
      });
    }

    if ((this.state.initialSelectedLeagueDetails === null && this.props.earlyPayoutSettings !== null)
      || (!this.state.hasChanges && (prevState.selectedLeagueId !== this.state.selectedLeagueId))) {
      const selectedLeagueDetails = this.getSelectedTeamsDetails();
      this.setState({
        initialSelectedLeagueDetails: selectedLeagueDetails,
        selectedLeagueDetails,
      });
    }
    if (prevState.hasChanges === false && this.state.hasChanges === true) {
      this.props.setNavigationInfo({ requiresSaveBeforeNavigation: true });
    }
  }

  updateSelectedLeague = (leagueId) => {
    if (this.state.hasChanges) {
      this.setState({ nextLeagueId: leagueId });
      this.props.setOpenModal({ modal: MODALS.SAVE_BEFORE_NAVIGATION });
    } else {
      this.setState({
        selectedLeagueId: leagueId,
      });
    }
  };

  getLeaguesName = () => this.props.leagues?.find((league) => league?.id
    === this.state.selectedLeagueId)?.name;

  getSelectedTeamsDetails = () => {
    if (this.state.earlyPayoutSettings !== null) {
      return this.state?.earlyPayoutSettings
        ?.find((details) => (details?.competitionId === this.state.selectedLeagueId))
        ?.config;
    }
    return null;
  };

  getMarketName = (marketId) => {
    if (!marketId) return '';
    return this.props.allMarkets?.find((market) => market.id === marketId)?.name;
  };

  handleInputChange = (marketId, type, value = null) => {
    const updatedSelectedLeagueDetails = [...this.state.selectedLeagueDetails];
    const idx = this.state.selectedLeagueDetails?.findIndex((settings) => settings?.marketId === marketId);
    const earlyPayoutSettings = { ...this.state.selectedLeagueDetails?.find((settings) => settings?.marketId === marketId) };

    if (earlyPayoutSettings) {
      if (type === EARLY_PAYOUT_INPUT.CHECKBOX) {
        earlyPayoutSettings.enabled = !earlyPayoutSettings.enabled;
      } else if (type === EARLY_PAYOUT_INPUT.THRESHOLD) {
        earlyPayoutSettings.threshold = value;
      } else if (type === EARLY_PAYOUT_INPUT.MINIMUM_SLOT) {
        earlyPayoutSettings.minimumSlot = value;
      }
      earlyPayoutSettings.editted = true;

      updatedSelectedLeagueDetails[idx] = earlyPayoutSettings;
      this.setState({
        selectedLeagueDetails: updatedSelectedLeagueDetails,
        hasChanges: true,

      });
    }
  };

  restoreInitialSettings = () => {
    this.setState({
      selectedLeagueDetails: this.state.initialSelectedLeagueDetails,
      hasChanges: false,
      showCancelModal: false,
      errors: {},
    });
    this.props.setNavigationInfo({ requiresSaveBeforeNavigation: false });
  };

  toggleCancelChangesModal = () => {
    this.setState({
      showCancelModal: !this.state.showCancelModal,
    });
  };

  clearErrors = () => {
    this.setState({
      errors: {},
    });
  };

  updateState = () => {
    const updatedEarlyPayoutSettings = [...this.state.earlyPayoutSettings];
    const compIdx = this.state.earlyPayoutSettings?.findIndex((comp) => comp?.competitionId === this.state.selectedLeagueId);
    const compDetails = { ...this.state.earlyPayoutSettings?.find((comp) => comp?.competitionId === this.state.selectedLeagueId) };

    const updatedConfig = this.state.selectedLeagueDetails?.map((marketDetails) => ({
      marketId: marketDetails?.marketId,
      threshold: Number(marketDetails?.threshold),
      enabled: marketDetails?.enabled,
      minimumSlot: Number(marketDetails?.minimumSlot),
    }));

    compDetails.config = updatedConfig;

    updatedEarlyPayoutSettings[compIdx] = compDetails;

    this.setState({
      earlyPayoutSettings: updatedEarlyPayoutSettings,
      initialSelectedLeagueDetails: updatedConfig,
      selectedLeagueDetails: updatedConfig,
      hasChanges: false,
    });
  };

  handleSave = () => {
    this.clearErrors();

    const validationParams = [];
    for (let i = 0; i < this.state.selectedLeagueDetails?.length; i += 1) {
      if (this.state.selectedLeagueDetails[i]?.enabled) {
        validationParams.push({
          label: 'Probability Threshold',
          fieldName: `probabilityThreshold-${i}`,
          value: this.state.selectedLeagueDetails?.[i]?.threshold,
          rules: ['betweenXAndY'],
          minValue: 0,
          comparatorMaxValue: 1,
          getValue: (val) => val,
        },
        {
          label: 'Minimum Slot',
          fieldName: `minimumSlot-${i}`,
          value: this.state.selectedLeagueDetails?.[i]?.minimumSlot,
          rules: ['betweenXAndY'],
          minValue: 0,
          comparatorMaxValue: 90,
          getValue: (val) => val,
        });
      }
    }

    validateFields(validationParams)
      .then(() => {
        this.props.saveEarlyPayoutSettings({
          competitionId: this.state.selectedLeagueId,
          marketDetails: this.state.selectedLeagueDetails,
        });

        this.props.setNavigationInfo({ requiresSaveBeforeNavigation: false });
        this.updateState();
      }).catch((errorMgs) => {
        this.setState({
          errors: errorMgs,
        });
      });
  };

  discardChangesAndProceed = () => {
    this.props.setOpenModal({ modal: '' });

    if (this.state.nextLeagueId !== this.state.selectedLeagueId) {
      this.setState({
        hasChanges: false,
        selectedLeagueId: this.state.nextLeagueId,
        nextLeagueId: null,
        errors: {},
      });
    }
    this.props.setNavigationInfo({ requiresSaveBeforeNavigation: false });
    if (this.props.nextNavigationLink) {
      this.props.navigate(this.props.nextNavigationLink);
    }
  };

  render() {
    const hasPermissionToUpdate = this.props.checkPermisson(PERMISSIONS.EARLY_PAYOUT_CONFIG_UPDATE);

    return (
      <>
        <div className="tab m-t-20">
          <div className="tab__link-wrap scroll">
            {this.props.leagues?.map((league) => (
              <div
                key={`league-header-${league?.id}`}
                className={`tab__link ${this.state.selectedLeagueId === league?.id ? 'is-active' : ''}`}
                id={league?.id}
                onClick={this.updateSelectedLeague.bind(this, league?.id)}
              >
                {league?.name}
              </div>
            ))}
          </div>

          <div className="tab__txt">
            Settings for
            {' '}
            {this.getLeaguesName()}
          </div>

          <div className="tab__content is-active">
            <div className="table-wrapper">
              <div className="table-responsive fix-15">
                <table className="table-style table-style--fixed">
                  <thead>
                    <tr>
                      <th>Market</th>
                      <th>Enabled</th>
                      <th>Probability Threshold</th>
                      <th>Minimum Slot / mins</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.selectedLeagueDetails?.map((leagueDetail, idx) => (

                      <EarlyPayoutSettingsRow
                        key={`leagueDetailsRow-${idx}`}
                        leagueDetail={leagueDetail}
                        getMarketName={this.getMarketName}
                        handleInputChange={this.handleInputChange}
                        hasPermissionToUpdate={hasPermissionToUpdate}
                        errors={this.state.errors}
                        idx={idx}
                      />

                    ))}

                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>

        {hasPermissionToUpdate && (
          <div className="m-t-30 p-r-30 text-right" disabled={!this.state.hasChanges}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleCancelChangesModal}
            >
              Cancel
            </button>
            {' '}
            <button
              type="button"
              className="btn btn-primary m-l-10"
              onClick={this.handleSave}
            >
              Save
            </button>
          </div>
        )}

        {this.state.showCancelModal ? (
          <>
            <div className="overlay-mask overlay-mask--open" />
            <div className="modal modal--open">
              <ConfirmationModal
                modalData={{
                  heading: 'Discard Changes',
                  title: `Are you sure you want to cancel the changes for ${this.getLeaguesName()}`,
                  additionalMessages: [],
                }}
                cancel={this.toggleCancelChangesModal}
                confirmation={this.restoreInitialSettings}
              />
            </div>
          </>
        ) : null}

        {this.props.activeModal === MODALS.SAVE_BEFORE_NAVIGATION && (
          <SavePromptModal
            modalData={{
              title: 'Do you want to save the changes?',
              additionalMessages: ['Your changes will be lost if you don\'t save them'],
            }}
            cancel={this.discardChangesAndProceed}
            confirmation={this.handleSave}
            confirm="Save"
            cancelled="Don't Save"
          />
        )}

      </>

    );
  }
}

export default connect(mapToProps, actionsToProps)(EarlyPayoutConfig);
